import {gql} from '@apollo/client';

export const GET_DSP_DELIVERY_TASK_REVIEW_LIST = gql`
  query GetDspDeliveryTaskReviewList($dspId: Long!, $warehouseId: Long!) {
    getDspDeliveryTaskReviewList(dspId: $dspId, warehouseId: $warehouseId) {
          orderIdList
          unScanCount
          routeName
          driverName
          driverPhone
          driverAccountId
    }
  }
`;

export interface DspDeliveryTaskReviewListResponse {
    getDspDeliveryTaskReviewList: DspDeliveryReviewDetailType[];
}

export interface DspDeliveryReviewDetailType {
    orderIdList: number[]
    unScanCount: number
    routeName: string
    driverName: string
    driverPhone: string
    driverAccountId: number
}

